import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box, Checkbox, FormControlLabel, useTheme } from "@mui/material";
import { Controller, } from "react-hook-form";
import { ErrorWithIcon } from "./ValidationMessage";
export const HCheckbox = forwardRef(({ label, checked = false, errormsg, rules, onChange, disabled = false, size = "medium", mt = 0, name, control, }, ref) => {
    const theme = useTheme();
    const handleCheckboxChange = (event) => {
        if (onChange) {
            onChange(event.target.checked);
        }
    };
    return (_jsx(Box, { mt: mt, children: _jsx(Controller, { name: name, control: control, rules: rules, render: ({ field }) => (_jsxs(_Fragment, { children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { ...field, checked: field.value || false, 
                            // onChange={(e) => {
                            //   handleCheckboxChange(e);
                            //   field.onChange(e);
                            // }}
                            onChange: (e) => {
                                field.onChange(e.target.checked); // Update form state
                                if (onChange) {
                                    onChange(e.target.checked);
                                }
                            }, sx: { mt: '-5px' }, disabled: disabled, size: size }), label: label, labelPlacement: "end", sx: {
                            alignItems: "start",
                            "& .MuiFormControlLabel-label": {
                                color: '#00244D',
                                fontSize: '16px'
                            },
                        } }), _jsx(ErrorWithIcon, { error: errormsg })] })) }) }));
});
